module.exports = __webpack_public_path__ + "img/logo.39c7b2ae.png";